import { FreeAccess } from '../Icons/CustomIcons';
import { Checkbox } from './Checkbox';


export const FreeAccessibleCheckbox = ({
  checked,
  onCheckedChange,
  icon: Icon = FreeAccess,
  iconSize = 17,
  showFieldInfo = false,
  fieldInfoText = '',
}) => (
  <div className="wheelchair-filter">
    <Checkbox
      id="free-accessible"
      checked={checked}
      onCheckedChange={onCheckedChange}
      label={
        <span className="body Font-M-S-130-T Colors-Black free-accessible-checkbox__label">
          <span className="icon-wrap-free-access">
            <Icon size={iconSize} color="var(--Colors-White)" />
          </span>
          Nur frei zugängliche Aktivitäten
        </span>
      }
    />
  </div>
);
